import { render, staticRenderFns } from "./MeetYourTeam.vue?vue&type=template&id=63639f90&"
import script from "./MeetYourTeam.vue?vue&type=script&lang=js&"
export * from "./MeetYourTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports